import { createFileRoute } from '@tanstack/react-router';
import SingleDigitalGateway from '../../../administration/src/components/Apps/AppDetails/SingleDigitalGateway';
import { withModalOutlet } from '../-withModalOutlet';

export const Route = createFileRoute('/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit')({
  component: withModalOutlet(SingleDigitalGateway),
});
